import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const CampaignContext = createContext();

const CampaignContextProvider = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [filterStatus, setFilterStatus] = useState(() => {
    const val = searchParams.get('status');
    return val || 'none';
  });
  const [filterApprovalStatus, setFilterApprovalStatus] = useState(() => {
    const val = searchParams.get('approvalStatus');
    return val || 'none';
  });
  const [filterCurrency, setFilterCurrency] = useState(() => {
    const val = searchParams.get('currency');
    return val ? parseInt(val, 10) : '';
  });
  const [filterPodLeader, setFilterPodLeader] = useState(() => {
    const val = searchParams.get('podLeader');
    return val ? parseInt(val, 10) : '';
  });
  const [filterStartFrom, setFilterStartFrom] = useState(() => {
    const val = searchParams.get('dateStartFrom');
    return val ? new Date(val) : '';
  });
  const [filterStartTo, setFilterStartTo] = useState(() => {
    const val = searchParams.get('dateStartTo');
    return val ? new Date(val) : '';
  });
  const [filterEndFrom, setFilterEndFrom] = useState(() => {
    const val = searchParams.get('dateEndFrom');
    return val ? new Date(val) : '';
  });
  const [filterEndTo, setFilterEndTo] = useState(() => {
    const val = searchParams.get('dateEndTo');
    return val ? new Date(val) : '';
  });

  const [filterTo, setFilterTo] = useState('');
  const [filterFrom, setFilterFrom] = useState('');

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const [fromStart, setFromStart] = useState('');
  const [toStart, setToStart] = useState('');

  const [fromEnd, setFromEnd] = useState('');
  const [toEnd, setToEnd] = useState('');
  return (
    <CampaignContext.Provider
      value={{
        filterStatus,
        setFilterStatus,
        filterApprovalStatus,
        setFilterApprovalStatus,
        filterCurrency,
        setFilterCurrency,
        filterPodLeader,
        setFilterPodLeader,
        filterStartFrom,
        setFilterStartFrom,
        filterStartTo,
        setFilterStartTo,
        filterEndFrom,
        setFilterEndFrom,
        filterEndTo,
        setFilterEndTo,
        filterFrom,
        setFilterFrom,
        filterTo,
        setFilterTo,
        from,
        setFrom,
        to,
        setTo,
        fromStart,
        setFromStart,
        toStart,
        setToStart,
        fromEnd,
        setFromEnd,
        toEnd,
        setToEnd,
      }}
    >
      {props.children}
    </CampaignContext.Provider>
  );
};

export default CampaignContextProvider;
